
<template>
    <div class="row wrapper border-bottom white-bg page-heading mb-2">
        <div class="d-flex align-self-center justify-content-between">
        <h2 class="mt-0">{{ $t("navigations.critical process") }}</h2>
        </div>
    </div>

  <div class="ibox-content">
    <div class="mb-2">
      <div class="form-group row mb-1">
        <div class="d-flex flex-column flex-lg-row justify-content-lg-start my-2 my-lg-0">
            <div class="col-12 col-md-5 my-1 my-lg-0 pl-lg-0 pr-lg-1">
                <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.process id") }}</label>
                <input type="text" class="form-control" v-model="processId" id="riskId" />
                </div>
            </div>
            <div class="col-12 col-md-5 my-1 my-lg-0 pl-lg-0 pr-lg-1">
                <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.process name") }}</label>
                <input type="text" class="form-control" v-model="processName" id="version" />
                </div>
            </div>
            <div class="col-12 col-md-2 save_btn w-100 align-self-end"
                type="button"
                @click.prevent="getCriticalProcess()"
            >
                {{ $t("navigations.search") }}
            </div>
        </div>
        </div>
    </div>
    <div class="ibox-content data-grid-container">
         <template v-if="showTableLoader == true">
            <div class="text-center">
                <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class=""
                    alt="Waiting for login"
                />
                <div>
                    {{ $t("navigations.please wait while the list is being loaded") }}
                </div>
            </div>
        </template>
        <template v-else>
             <div class="table-responsive custom-dark-table-wrapper">
                <table class="table table-striped dark-table-head mb-0">
                    <thead>
                        <tr>
                            <th class="text-center"> {{ $t("navigations.process id") }}</th>
                            <th class="text-center"> {{ $t("navigations.process name") }}</th>
                            <th class="text-center"> {{ $t("navigations.critical points") }}</th> 
                        </tr>
                    </thead>
                    <tbody class="custom-table-wrapper">
                        <tr v-for="item in criticalDataPoints" :key="item.id">
                            <td class="text-center"> {{ item.processId }}</td>
                            <td class="text-center"> {{ item.processName }}</td>
                            <td class="text-center"> 
                                <div class="position-relative cursor-pointer"
                                     @click="showCriticalDP(item)">
                                    <i class="fa fa-ellipsis-v"></i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
  </div>

  <CriticalDPModal
    v-if="showCriricalPopUp"
    :criticalInfo="selectedCriticalDP"
    formPage="Critical data inventory"
    @closeModal="closeCriticalDataPopup"
  />

</template>

<script src="./CriticalDataInventory.js"></script>

<style scoped>

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

</style>